<template>
  <div class="i-cta-banner">
    <div class="cta-banner__text">
      <div class="cta-banner__headline">{{ headline }}</div>
      <div class="cta-banner__sub">{{ sub }}</div>
    </div>
    <div class="cta-banner__price">
      <span class="cta-banner__price-was">${{ highPricing }}</span>
      <span class="cta-banner__price-now">${{ pricing }}</span>
    </div>
    <a
      class="cta-banner__btn"
      href="#book"
      @click.prevent="$emit('book')"
      >Add session — ${{ pricing }}</a
    >
  </div>
</template>

<script setup lang="ts">
defineEmits(["book"])

// PROPS
defineProps({
  headline: { type: String, required: true },
  sub: { type: String, required: true },
  pricing: {
    type: String,
    default: "49"
  },
  highPricing: {
    type: String,
    default: "149.90"
  }
})
</script>

<style lang="scss" scoped>
.i-cta-banner {
  background: var(--grad-primary);
  border-radius: 16px;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 760px;
  box-shadow: 0 8px 32px #5b4cff40;
  flex-flow: column wrap;
  align-items: stretch;
  padding: 24px 20px;
  gap: 16px;
  text-align: center;

  @include respond-to(600px) {
    padding: 28px 32px;
    align-items: center;
    gap: 20px;
    text-align: unset;
    flex-direction: unset;
  }

  .cta-banner {
    &__text {
      flex: 1;
      min-width: 220px;
    }

    &__headline {
      font-size: 1.05rem;
      font-weight: 800;
      color: white;
      line-height: 1.35;
      margin-bottom: 4px;
    }

    &__sub {
      font-size: 0.82rem;
      color: #ffffffb3;
      line-height: 1.5;
    }

    &__price {
      display: flex;
      align-items: baseline;
      gap: 8px;
      flex-shrink: 0;
      justify-content: center;

      @include respond-to(600px) {
        justify-content: unset;
      }
    }

    &__price-was {
      font-size: 0.9rem;
      color: #ffffff73;
      text-decoration: line-through;
      font-weight: 400;
    }

    &__price-now {
      font-size: 2.2rem;
      font-weight: 800;
      color: white;
      line-height: 1;
    }

    &__btn {
      display: inline-flex;
      align-items: center;
      padding: 12px 24px;
      background: white;
      color: var(--purple);
      font-size: 0.88rem;
      font-weight: 700;
      border: none;
      border-radius: 10px;
      cursor: pointer;
      text-decoration: none;
      transition:
        transform 0.15s,
        box-shadow 0.15s;
      white-space: nowrap;
      flex-shrink: 0;
      box-shadow: 0 2px 12px #0000001a;
      width: 100%;
      justify-content: center;

      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 16px #00000026;
      }

      @include respond-to(600px) {
        justify-content: unset;
        width: unset;
      }
    }
  }
}
</style>
